import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import './create-session.scss';
import { Field, getFormSubmitErrors, reduxForm, SubmissionError } from 'redux-form';
import {
  createSession,
  getCategorySessions,
  getDetailSession,
  getDetailTopic,
  getListBuddyRole,
  updateSession,
  uploadFile, verifySlotSession,
  getListDurationByLevel
} from 'redux/actions/mvp/session.action';
import UploadImageAdapterPlugin from './UploadImageAdapterPlugin';
import Select from 'react-select';
import { TimePicker, Tooltip } from 'antd';
// import ReactQuill from "react-quill";
// import 'react-quill/dist/quill.snow.css';
import { cloneDeep, isEqual } from 'lodash';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import KambriaEditor from '@kambria/ckeditor5-react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';


import remove from 'static/images/mvp/remove.png';
import warning from 'static/images/mvp/warning.png';
import question from 'static/svg/question.svg';

import { toast } from 'react-toastify';
import ConfigTimeSlots from './config-time-slots';
import {
  changeDateLocaleToUTC,
  changeDateUTCToLocale,
  convertToGMTLocal, convertToUTC,
  dataTimesDefault,
  daysOfWeek,
  getDayOfWeek, getTimeRangeLocale,
  getTimeRangeUtc,
  mapDateTimeToUtc,
} from './helper';
import moment from 'moment';
import arrowBackIcon from '../../../../static/svg/back.svg';
import { I18n } from '../../../../helpers/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap4-modal';
import { NotVerifiedModal } from 'views/components/core/modals';

const FORM_NAME = 'formCreateSession';
const classErrorGeneral = 'input-error';
const INPUT_EN_FIELDS = [
  'titleEn',
  'personalDescriptionEn',
  'descriptionEn',
];
const INPUT_VN_FIELDS = [
  'title',
  'personalDescription',
  'description',
]
const SELECT_FIELDS = ['categoryId'];
const locale = I18n.language === 'vi' ? 'vi-VN' : 'en-US';

class CreateSession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionId: props.match.params.id || '',
      categories: [],
      file: null,
      previewLink: null,
      personalDescription: '',
      description: '',
      isDuplicate: 0,
      isCreate: 1,
      buddyRoles: [],
      durationTimes: [],
      roleBuddyInSession: 'volunteer',
      duration: 20,
      timeSlotTypeChoose: 'limit',
      timeSlotStart: null,
      timeSlotEnd: null,
      timeSlotConfig: false,
      timeSlotConfigOne: false,
      activeDateCalendar: null,
      oneSessionTime: { start: '08:00', end: '08:45' },
      oneSessionDataTime: null,
      oneSessionMessages: '',
      oneSessionOverlapWiths: [],
      isConfigOneSlot: false,
      isOneSlotTopic: false,
      dataTime: [],
      oldDataTime: [],
      languages: [],
      showNotVerifiedModal: false,
      sessionDetail: null,
    };
    this.inputFileRef = React.createRef();
    this.timeSlotsRef = null;
    this.languagesRef = null;
    this.timeSlotsValid = true;
    this.calendarRef = React.createRef();
    this.ckEditorInstances = new Map(); // Store CKEditor instances for cleanup
  }

  componentWillUnmount() {
    // Cleanup all CKEditor instances
    this.ckEditorInstances.forEach((editor, name) => {
      try {
        if (editor && editor.destroy) {
          editor.destroy();
        }
      } catch (error) {
        // Ignore errors during cleanup (DOM might already be removed)
        console.warn(`Error destroying CKEditor instance for ${name}:`, error);
      }
    });
    this.ckEditorInstances.clear();
  }

  async componentDidMount() {
    let language = localStorage.getItem('ced:language') || "vi"
    this.setState({ languages: [language] });
    const { getCategorySessions, getListBuddyRole, getDetailTopic, getListDurationByLevel } = this.props;
    let [categories, buddyRoles,
      durationTimes] = await Promise.all([
      getCategorySessions(),
      getListBuddyRole(),
      getListDurationByLevel(),
    ]);

    if (buddyRoles) {
      this.setState({ buddyRoles: buddyRoles });
    }

    if (categories) {
      categories = categories.map(item => ({
        _id: item._id,
        name: item.name,
        children: item.children,
      }));
    }
    this.setState({ categories: categories });
    if (durationTimes) {
      this.setState({ durationTimes: durationTimes });
    }
    if (window.location.pathname.includes('update-session')) {
      this.setState({ isCreate: 0 });
    }
    if (this.state.sessionId) {
      const sessionDetail = await getDetailTopic({ topicId: this.state.sessionId });
      let dataTimes = sessionDetail?.dataTimeSetup ? cloneDeep(sessionDetail?.dataTimeSetup) : [];
      let timeSlotTypeChoose = 'unlimit';
      let timeToLocale = {};
      if (sessionDetail?.endTime) {
        timeSlotTypeChoose = 'limit';
        timeToLocale = getTimeRangeLocale(sessionDetail?.startTime, sessionDetail?.endTime);
      }
      let languages = []
      if(sessionDetail?.languages) {
        if (Array.isArray(sessionDetail?.languages)) {
          sessionDetail?.languages.forEach(language => {
            if (!language || language === '') {
              return
            }

            if (['Tiếng Việt','Vietnamese'].includes(language)) {
              languages.push('vi')
            }

            if (['Tiếng Anh','English'].includes(language)) {
              languages.push('en')
            }
          })
        } else {
          languages = JSON.parse(sessionDetail.languages)

        }
      } else {
        languages = [language]
      }
      // Format categoryId để tương thích với component mới
      let categoryIdFormatted = null;
      if (sessionDetail?.dataCategory) {
        const cat = sessionDetail.dataCategory;
        // Nếu đã là object có value/label thì giữ nguyên, nếu chỉ là object có _id/name thì format lại
        if (cat.value && cat.label) {
          categoryIdFormatted = cat;
        } else if (cat._id && cat.name) {
          categoryIdFormatted = { value: cat._id, label: cat.name };
        } else if (typeof cat === 'string') {
          // Nếu chỉ là string _id, cần tìm category để lấy name
          categoryIdFormatted = cat; // Tạm thời giữ string, component sẽ xử lý
        }
      }

      const dataInit = {
        title: sessionDetail?.titleVn || sessionDetail?.title,
        titleEn: sessionDetail?.titleEn || '',
        languages: languages,
        categoryId: categoryIdFormatted,
        description: sessionDetail?.descriptionVn || sessionDetail?.description,
        descriptionEn: sessionDetail?.descriptionEn || '',
        personalDescription: sessionDetail?.personalDescriptionVn || sessionDetail?.personalDescription,
        personalDescriptionEn: sessionDetail?.personalDescriptionEn || '',
        roleBuddyInSession: sessionDetail?.roleBuddyInSession || 'volunteer',
        duration: sessionDetail?.duration ? Number(sessionDetail.duration) : 20,
        image: null,
        timeSlotStart: timeToLocale?.timeSlotStart || null,
        timeSlotEnd: timeToLocale?.timeSlotEnd || null,
        timeSlotTypeChoose: timeSlotTypeChoose
      };

      if (sessionDetail?.duration) {
        const startTime = moment('08:00', 'HH:mm');
        const endTime = startTime.clone().add(sessionDetail.duration, 'minutes');
        this.setState({
          oneSessionTime: {
            start: '08:00',
            end: endTime.format('HH:mm')
          }
        });
      }


      if (dataTimes.length) {
        const dateNeedAdd = {};
        dataTimes.forEach(time => {
          if (typeof time === 'string') {
            return;
          }
          time.apply = true;
          const slotNeedSubtract = [];
          let startDate = time.startDate;
          time.data.forEach((slots) => {
            const dateInWeek = changeDateUTCToLocale(startDate, slots.start);
            startDate = dateInWeek ? dateInWeek : startDate;
            slots.start = convertToGMTLocal(slots.start);
            slots.end = convertToGMTLocal(slots.end);
            if (slots.startTimeOneSlot) {
              slots.startTimeOneSlot = convertToGMTLocal(slots.startTimeOneSlot);
              slots.endTimeOneSlot = convertToGMTLocal(slots.endTimeOneSlot);
            }

            if (!dateInWeek) {
              return;
            }

            slotNeedSubtract.push(slots.start);
            if (dateNeedAdd[startDate]) {
              dateNeedAdd[startDate].push(slots);
            } else {
              dateNeedAdd[startDate] = [slots];
            }
          });

          if (slotNeedSubtract.length) {
            time.data = time.data.filter(slots => !slotNeedSubtract.includes(slots.start));
          }

          if (!time.data.length) {
            time.apply = false;
          }
        });

        dataTimes = dataTimesDefault().map(item => {
          const { startDate } = item;
          item.apply = false;
          item.label = daysOfWeek()[startDate];
          const check = dataTimes.find(time => time.startDate === startDate);
          if (check && check.data.length) {
            check.label = daysOfWeek()[check.startDate];
            return check;
          }
          return item;
        });

        if (Object.keys(dateNeedAdd).length) {
          dataTimes.forEach(date => {
            const newDate = { ...date };
            const { startDate } = newDate;
            if (!dateNeedAdd[startDate]) {
              return;
            }
            if (!date.apply) {
              date.apply = true;
              date.data = [];
            }
            date.data = date.data.concat(dateNeedAdd[startDate]);
          });
        }
        dataInit.dataTime = dataTimes
        dataInit.oldDataTime = cloneDeep(dataTimes)
      }
      if (sessionDetail?.isOneSlotTopic) {
        dataInit.activeDateCalendar = timeToLocale?.timeSlotStart
        dataInit.isConfigOneSlot = true
        dataInit.isOneSlotTopic = true
        const slotTime = dataTimes.find((time) => time.apply)?.data
        dataInit.oneSessionTime = slotTime ? slotTime[0]: null
      }

      const imageLink = sessionDetail?.images?.length ? sessionDetail.images[0] : '';
      if (imageLink) {
        this.setState({ previewLink: imageLink });
      }
      this.setState({ ...dataInit, sessionDetail: {...dataInit} })
      this.props.initialize(dataInit);
    }
  }

  timeSlotInfo = () => {
    const { dataTime, timeSlotTypeChoose, timeSlotStart, timeSlotEnd, isConfigOneSlot, activeDateCalendar, oneSessionTime } = this.state;
    if (isConfigOneSlot) {
      return [`${I18n.t('config_one_session')}: ${moment(activeDateCalendar)?.format('DD/MM/YYYY')} ${oneSessionTime.start} - ${oneSessionTime.end}`];
    }
    const keyTypeToMessage = {
      'limit': I18n.t('time_slot_type_range'),
      // 'unlimit': I18n.t('time_slot_type_expiration'),
    };
    let typeMessage = keyTypeToMessage[timeSlotTypeChoose];
    if (timeSlotTypeChoose === 'limit') {
      const start = timeSlotStart ? timeSlotStart?.format('DD/MM/YYYY') : '';
      const end = timeSlotEnd ? timeSlotEnd?.format('DD/MM/YYYY') : '';
      typeMessage = start ? `${typeMessage}: ${start} - ${end}` : `${typeMessage}:`;
    }
    if (!dataTime || !dataTime.length) {
      return [typeMessage];
    }
    let totalSlot = 0;
    const data = dataTime.filter(item => item.apply).map((day) => {
      const slots = day.data.map((slot) => ({ start: slot.start, end: slot.end }));
      totalSlot += slots.length;
      return {
        startDate: day.startDate,
        label: day.label,
        data: slots,
      };
    });

    let slotsMessage = I18n.t('number_session_in_week', { number: totalSlot });
    if (totalSlot === 1) {
      slotsMessage = `${data[0].label}, ${data[0].data[0].start} - ${data[0].data[0].end}`;
    }
    return [
      typeMessage,
      slotsMessage,
    ];
  };

  renderInput = ({ input, label, type, placeholder, meta: { touched, error }, disabled, col = 6 }) => {
    let classError = '';
    if (error) {
      classError = classErrorGeneral;
    }
    return (
      <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12`}>
                <span className="label d-block mt-3 mb-2" id={input.name}>
                  {label} <small className="error">*</small>
                </span>
        <input {...input}
               disabled={disabled}
               className={'w-100 form-control input-text ' + classError}
               type={type}
               placeholder={placeholder}
        />

        {error && error == 'max_length' && (
          <span className="error-message">
            <img src={warning} style={{ marginTop: '-5px' }} />
            {I18n.t('session_title_max_length')}
          </span>
        )}
      </div>
    );
  };

  renderSelect = ({ label, input, options, disabled, selectProps, meta: { touched, error }, col = 6 }) => {
    let classError = '';
    if (error) {
      classError = classErrorGeneral;
    }
    return (
      <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12`}>
              <span className="label d-block mt-3 mb-2" id={input.name}>
                 {label} <small className="error">*</small>
              </span>
        <Select
          {...input}
          {...selectProps}
          isDisabled={disabled}
          className={'w-100 ' + classError}
          onChange={(value) => input.onChange(value)}
          onBlur={(event) => event.preventDefault()}
          options={options}
          isClearable={false}
          components={{
            DropdownIndicator: null,
          }}
          classNamePrefix="filter"
        />
      </div>
    );
  };

  renderCategorySelect = ({ label, input, options, disabled, meta: { touched, error }, col = 6 }) => {
    const [selectedParent, setSelectedParent] = React.useState(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const wrapperRef = React.useRef(null);

    // Tìm parent và child đang được chọn từ input.value
    const findSelectedCategory = () => {
      // input.value có thể là object {value, label} hoặc string _id
      const selectedId = input.value?.value || input.value;

      if (!selectedId) return { parent: null, child: null };

      for (const parent of options) {
        if (parent._id === selectedId) {
          return { parent, child: null };
        }
        if (parent.children && parent.children.length > 0) {
          const child = parent.children.find(c => c._id === selectedId);
          if (child) {
            return { parent, child };
          }
        }
      }
      return { parent: null, child: null };
    };

    const { parent: currentParent, child: currentChild } = findSelectedCategory();

    // Xử lý click bên ngoài để đóng dropdown
    React.useEffect(() => {
      const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      }

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen]);

    // Hiển thị breadcrumb
    const getSelectedText = () => {
      if (currentChild) {
        return `${currentParent.name} > ${currentChild.name}`;
      }
      if (currentParent) {
        return currentParent.name;
      }
      return I18n.t('select_topic') || 'Chọn danh mục';
    };

    // Xử lý click vào parent category
    const handleParentClick = (parent) => {
      setSelectedParent(parent);
    };

    // Xử lý click vào child category
    const handleChildClick = (child) => {
      // Lưu theo format object như react-select để tương thích với logic submit
      input.onChange({
        value: child._id,
        label: child.name,
      });
    };

    // Lấy danh sách children để hiển thị
    const displayParent = selectedParent || currentParent;
    const childrenList = displayParent && displayParent.children ? displayParent.children : [];

    let classError = '';
    if (error) {
      classError = classErrorGeneral;
    }

    return (
      <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12`}>
        <span className="label d-block mt-3 mb-2" id={input.name}>
          {label} <small className="error">*</small>
        </span>

        <div className={`category-select-wrapper ${classError}`} ref={wrapperRef}>
          {/* Input Display */}
          <div
            className={`category-select-input ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => !disabled && setIsOpen(!isOpen)}
          >
            <span className={currentChild ? 'input-value' : 'input-placeholder'}>
              {currentChild ? getSelectedText() : (I18n.t('select_topic') || 'Choose a category')}
            </span>
          </div>

          {/* Dropdown Panel */}
          {isOpen && (
            <div className="category-select-dropdown">
              {/* Selected Display - nằm trên dropdown */}
              {currentChild && (
                <div className="category-selected-header">
                  <span className="label-small">{I18n.t('selected') || 'Selected'}: {getSelectedText()}</span>
                </div>
              )}

              <div className="category-columns">
                {/* Left Column - Parent Categories */}
                <div className="category-column parent-column">
                  {options.map((parent) => (
                    <div
                      key={parent._id}
                      className={`category-item ${displayParent?._id === parent._id ? 'active' : ''}`}
                      onClick={() => handleParentClick(parent)}
                    >
                      <span className="category-name">{parent.name}</span>
                      <span className="arrow-icon">›</span>
                    </div>
                  ))}
                </div>

                {/* Right Column - Child Categories */}
                <div className="category-column child-column">
                  {childrenList.map((child) => (
                    <div
                      key={child._id}
                      className={`category-item ${currentChild?._id === child._id ? 'selected' : ''}`}
                      onClick={() => handleChildClick(child)}
                    >
                      <span className="category-name">{child.name}</span>
                      {currentChild?._id === child._id && (
                        <FontAwesomeIcon
                          className="check-icon"
                          icon={faCheckCircle}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  buddyRoleSelect(value) {
    this.setState({ roleBuddyInSession: value });
  }

  durationSelect(value) {
    // Ensure duration is always a number
    const durationNum = Number(value);
    if (!isNaN(durationNum) && durationNum > 0) {
      this.setState({ duration: durationNum });
    }
  }

  buddyTimeslotTypeSelect = (value) => {
    this.setState({ timeSlotTypeChoose: value });
  };

  prepareTimeSlotConfig = (value) => {
    this.setState({ dataTime: value });
    this.timeSlotsValid = true;
  };

  timeSlotTypeDateChange = (timeSlotStart, timeSlotEnd) => {
    this.setState({ timeSlotStart: timeSlotStart, timeSlotEnd: timeSlotEnd });
  };

  toggleConfigTimeSlot = () => {
    let {dataTime, isOneSlotTopic, oldDataTime, isConfigOneSlot, sessionDetail, timeSlotTypeChoose} = this.state
    const checkEqual = isEqual(dataTime, oldDataTime)
    if (isOneSlotTopic && (checkEqual || !dataTime.length)) {
      this.setState({ dataTime: dataTimesDefault(), timeSlotTypeChoose: 'unlimit', activeDateCalendar: null })
    }
    if (!isOneSlotTopic && isConfigOneSlot && !checkEqual) {
      this.setState({ dataTime: oldDataTime, timeSlotTypeChoose: sessionDetail?.timeSlotTypeChoose || timeSlotTypeChoose })
    }
    this.setState({ timeSlotConfig: !this.state.timeSlotConfig, isConfigOneSlot: false });
  };

  toggleConfigOneSlot = () => {
    let {dataTime, isOneSlotTopic, oldDataTime, isConfigOneSlot, sessionDetail, activeDateCalendar} = this.state
    const checkEqual = isEqual(dataTime, oldDataTime)
    if (!isOneSlotTopic && checkEqual) {
      this.setState({ dataTime: [] })
    }

    if (isOneSlotTopic && !isConfigOneSlot) {
      this.setState({ dataTime: [], activeDateCalendar: sessionDetail?.activeDateCalendar || activeDateCalendar })
    }
    this.setState({ timeSlotConfigOne: !this.state.timeSlotConfigOne, isConfigOneSlot: true });

    const startTime = moment('08:00', 'HH:mm');
    const endTime = startTime.clone().add(this.state.duration, 'minutes');
    this.setState({
      oneSessionTime: {
        start: '08:00',
        end: endTime.format('HH:mm')
      }
    });
  }

  setActiveDateCalendar = (value) => {
    this.setState({ activeDateCalendar: value });
  }

  handleChangeTime = (time) => {

    if (time) {
      const newStart = time.format('HH:mm');
      const newEnd = time.add(this.state.duration || 45, 'minutes').format('HH:mm');
      this.setState({oneSessionTime: { start: newStart, end: newEnd }});
    }
  };


  saveConfig = async () => {
    const { activeDateCalendar, oneSessionTime } = this.state;
    if (!activeDateCalendar) {
      toast.error( I18n.t('config_one_session_step_1'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        className: 'toast-error-container toast-error-container-after',
        theme: 'colored',
      });
      return
    }

    const toMoment = moment(activeDateCalendar)
    let dayOfWeek = toMoment.format('dddd').toLowerCase();
    const { timeSlotEnd, timeSlotStart} = getTimeRangeUtc(toMoment, toMoment)
    const dayOfWeekUTC = changeDateLocaleToUTC(dayOfWeek, oneSessionTime.start)
    let start = convertToUTC(oneSessionTime.start);
    let end = convertToUTC(oneSessionTime.end);
    const { dataTime, timeSlotTypeChoose, sessionId } = this.state;
    let dataTimes = dataTime.length ? cloneDeep(dataTime) : dataTimesDefault().map(item => {
      item.apply = false;
      return item;
    });
    const mapTimeZoneResult = getTimeRangeUtc(activeDateCalendar, activeDateCalendar);

    dataTimes = dataTimes.map(item => {
      const itemData = item.data.filter(item => !item.startTimeOneSlot && item.apply)
      if (dayOfWeek !== item.startDate) {
        if (itemData.length === 1) {
          return {...item, apply: false};
        }
        return {...item, data: item.data.filter(item => !item.startTimeOneSlot)};
      }
      const newItem = { ...item, data: itemData, apply: true };
      const timeIndex = itemData.findIndex(t => t.start === oneSessionTime.start);
      if (timeIndex !== -1) {
        newItem.data = itemData.map((time, idx) =>
          idx === timeIndex ? {
            ...time,
            startTimeOneSlot: oneSessionTime.start,
            endTimeOneSlot: oneSessionTime.end,
            startTimeTopicOneSlot: mapTimeZoneResult.timeSlotStart,
            endTimeTopicOneSlot: mapTimeZoneResult.timeSlotEnd
          } : time
        );
      } else {
        newItem.data = [
          ...itemData,
          {
            start: oneSessionTime.start,
            end: oneSessionTime.end,
            startTimeOneSlot: oneSessionTime.start,
            endTimeOneSlot: oneSessionTime.end,
            startTimeTopicOneSlot: mapTimeZoneResult.timeSlotStart,
            endTimeTopicOneSlot: mapTimeZoneResult.timeSlotEnd
          }
        ];
      }

      return newItem;
    });

    if (dayOfWeekUTC) {
      dayOfWeek = dayOfWeekUTC
    }
    const params = {
      startDate: dayOfWeek,
      timeSlotStart: timeSlotStart,
      timeSlotEnd: timeSlotEnd,
      dataTime: [{start: start, end: end}],
      topicId: this.state.sessionId || ''
    };

    this.setState({
      oneSessionMessages: '',
      oneSessionOverlapWiths: [],
      dataTime: dataTimes,
    });
    const valid = await this.props.verifySlotSession(params);
    if (!valid.isValid) {
      const validSlot = valid.dataTime ? valid.dataTime[0] : null
      if (validSlot?.isValidStartBeforeEnd === false) {
        this.setState({ oneSessionMessages: I18n.t('session_st_before_et') });
      }

      if (validSlot?.isValidOverlap === false) {
        this.setState({ oneSessionMessages: I18n.t('session_date_time_error') });
      }
      if (validSlot?.overlapWiths?.length) {
        validSlot.overlapWiths.forEach(over => {
          let topicTime = ''
          if (over.startTimeTopic) {
            topicTime = ` ${I18n.t('session_time_range', {
              date: over.startTimeTopic && over.endTimeTopic ? `${moment(over.startTimeTopic).format('DD/MM/YY')} - ${moment(over.endTimeTopic).format('DD/MM/YY')}` : moment(over.startTimeTopic).format('DD/MM/YY'),
            })}`
          }
          let {startDate} = over
          const dateInWeek = changeDateUTCToLocale(startDate, over.startTimeSlot)
          startDate = dateInWeek ? dateInWeek : startDate
          this.setState(prevState => ({
            oneSessionOverlapWiths: [...prevState.oneSessionOverlapWiths, {
              timeSlot: `${daysOfWeek()[startDate.toLowerCase()]} / ${convertToGMTLocal(over.startTimeSlot)} - ${convertToGMTLocal(over.endTimeSlot)}${topicTime}`,
              session: over.sessionName,
            }]
          }));
        });
      }
      return
    }
    this.setState({ timeSlotConfigOne: false})
  }

  cancelConfig = () => {
    this.setState({
      timeSlotConfigOne: false,
      activeDateCalendar: null,
      isConfigOneSlot: false
    });

    if (this.state?.duration) {
      const startTime = moment('08:00', 'HH:mm');
      const endTime = startTime.clone().add(this.state?.duration, 'minutes');
      this.setState({
        oneSessionTime: {
          start: '08:00',
          end: endTime.format('HH:mm')
        }
      });
    }
  };

  renderImage = ({ label, input, previewLink, meta: { touched, error }, col = 6 }) => {
    let classError = '';
    if (error) {
      classError = classErrorGeneral;
    }
    let styleFileUpload = {
      backgroundImage: `url(${remove})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundColor: '#000000',
      borderRadius: '50%',
      width: '20px',
      height: '20px',
    };
    return (
      <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12`}>
                <span className="label d-block mt-3 mb-2" id={input.name}>
                  {label} <small className="error">*</small>
                </span>
        <div>
          <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12 p-0`}>
            {!previewLink && (<div className={`avatar-picker ${classError}`}
                                   onClick={this.onAvatarPickerClick}
            >
              <i style={{ color: '#4B5563' }} className="fas fa-plus" />
            </div>)}
            <input type="file" {...input}
                   ref={this.inputFileRef}
                   style={{ display: 'none' }}
                   accept="image/png, image/gif, image/jpeg"
                   name="image"
                   onChange={this.uploadDone}
            />
          </div>
          {previewLink && (<div className="preview-image">
            <img className="image-preview" src={this.state.previewLink} alt="pic1" />
            <div onClick={this.onRemoveAvatar} className="remove-image" style={styleFileUpload}></div>
          </div>)}
        </div>
      </div>
    );
  };

  renderTextarea = ({ label, input, meta: { touched, error }, disabled, col = 6 }) => {
    let classError = '';
    if (error) {
      classError = classErrorGeneral;
    }

    const modules = {
      toolbar: [
        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
          { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video'],
        ['clean'],
      ],
      clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
      },
    };
    const formats = [
      'header', 'font', 'size',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image', 'video',
    ];

    function UploadAdapterPlugin(editor) {
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new UploadImageAdapterPlugin(loader);
      };
    }

    const custom_config = {
      extraPlugins: [UploadAdapterPlugin],
      placeholder: input.name === 'personalDescription' ? I18n.t('session_goal_hint') : I18n.t('session_description_hint'),
      table: {
        contentToolbar: [
          'toggleTableCaption',
          'tableColumn',
          'tableRow',
          'mergeTableCells',
          'tableProperties',
          'tableCellProperties',
        ],
      },
      fontSize: {
        options: ['default', 12, 16, 18, 24, 32],
      },
      fontColor: {
        colors: [

          {
            color: '#e7e3e3',
            label: 'white',
          },
          {
            color: 'hsl(0, 75%, 60%)',
            label: 'Red',
          },
          {
            color: 'hsl(30, 75%, 60%)',
            label: 'Orange',
          },
          {
            color: 'hsl(60, 75%, 60%)',
            label: 'Yellow',
          },
          {
            color: 'hsl(90, 75%, 60%)',
            label: 'Light green',
          },
          {
            color: 'hsl(120, 75%, 60%)',
            label: 'Green',
          },
          {
            color: '#1AEEC2',
            label: 'Xanh Ngọc Kambria',
          },
        ],
        columns: 5,
      },
      heading: {
        options: [
          { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
          { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
          { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
          { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
          { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
          { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
          { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' },
        ],
      },
      image: {
        // You need to configure the image toolbar, too, so it uses the new style buttons.
        toolbar: [
          'imageTextAlternative',
          'toggleImageCaption',
          'linkImage',
          '|',
          'imageStyle:alignLeft',
          'imageStyle:alignCenter',
          'imageStyle:alignRight',
          '|',
          'resizeImage',
        ],
        styles: ['alignCenter', 'alignLeft', 'alignRight'],
        resizeOptions: [
          {
            name: 'resizeImage:original',
            value: null,
            icon: 'original',
          },
          {
            name: 'resizeImage:25',
            value: '25',
            icon: 'small',
          },
          {
            name: 'resizeImage:50',
            value: '50',
            icon: 'medium',
          },
          {
            name: 'resizeImage:75',
            value: '75',
            icon: 'large',
          },
          {
            name: 'resizeImage:100',
            value: '100',
            icon: 'original',
          },
        ],
      },
      link: {
        decorators: {
          openInNewTab: {
            mode: 'manual',
            label: 'Open link in a new tab',
            defaultValue: true, // This option will be selected by default.
            attributes: {
              target: '_blank',
            },
          },
        },
      },
      mediaEmbed: {
        previewsInData: true,
      },
    };
    return (
      <div className={`form-item col-12 col-xl-${col} col-lg-${col} col-md-12 col-sm-12`}>
                <span className="label d-block mt-3 mb-2 label-20" id={input.name}>
                  {label} <small className="error">*</small>
                </span>
        <div className="cktabs">
          <CKEditor
            name={input.name}
            data={input.value}
            onReady={(editor) => {
              if (!editor) return;
              editor.setData(input.value);
              // Store editor instance for cleanup
              this.ckEditorInstances.set(input.name, editor);
              const editableElement = editor.ui.getEditableElement();
              if (editableElement && editableElement.parentElement) {
                editableElement.parentElement.insertBefore(editor.ui.view.toolbar.element, editableElement);
              }
            }}
            onError={({ willEditorRestart }) => {
              if (willEditorRestart) {
                const editor = this.ckEditorInstances.get(input.name);
                if (editor && editor.ui && editor.ui.view && editor.ui.view.toolbar && editor.ui.view.toolbar.element) {
                  try {
                    editor.ui.view.toolbar.element.remove();
                  } catch (error) {
                    // Ignore if element is already removed
                    console.warn('Error removing toolbar element:', error);
                  }
                }
              }
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              input.onChange(data);
            }}
            editor={KambriaEditor}
            config={custom_config}
          />
        </div>
      </div>
    );
  };

  onAvatarPickerClick = () => {
    const { updatingProfilePicture } = this.props;
    if (updatingProfilePicture) return;
    this.inputFileRef.current.click();
  };

  uploadDone = (event) => {
    var file = event.target.files[0];
    if (file) {
      this.setState({ file: file });
      this.setState({ previewLink: URL.createObjectURL(event.target.files[0]) });
    }
  };

  onRemoveAvatar = () => {
    this.setState({ file: null });
    this.setState({ previewLink: null });
  };

  getInputFields = () => {
    let inputFields = []
    if (this.checkCfl('vi')) {
      inputFields = inputFields.concat(INPUT_VN_FIELDS)
    }
    if (this.checkCfl('en')) {
      inputFields = inputFields.concat(INPUT_EN_FIELDS)
    }
    return inputFields
  }

  validateFormData = async (values) => {
    const errors = {};
    const {dataTime, isConfigOneSlot, activeDateCalendar} = this.state;
    if (!isConfigOneSlot && !dataTime.length) {
      this.timeSlotsValid = false;
    }

    if (isConfigOneSlot && !activeDateCalendar) {
      this.timeSlotsValid = false;
    }

    if (values) {
      this.getInputFields().forEach((key) => {
        if (!values[key]) {
          errors[key] = 'required';
        }

        if ((key == 'title' || key == 'titleEn') && values[key] && values[key].length > 500) {
          errors[key] = 'max_length';
        }
      });

      SELECT_FIELDS.forEach((key) => {
        if (!values[key]) {
          errors[key] = 'required';
        }
      });

      if (!this.state.file && !this.state.previewLink) {
        errors['image'] = 'required';
      }
    }


    return errors;
  };

  calculateDataTimes() {
    let { timeSlotStart, timeSlotEnd, timeSlotTypeChoose, dataTime, isConfigOneSlot, activeDateCalendar } = this.state;
    let newSlotStart = timeSlotStart;
    let newSlotEnd = timeSlotEnd;
    if (isConfigOneSlot) {
      timeSlotStart = activeDateCalendar
      timeSlotEnd = activeDateCalendar
    }

    if (timeSlotTypeChoose === 'limit') {
      const mapTimeZoneResult = getTimeRangeUtc(timeSlotStart, timeSlotEnd);
      newSlotStart = mapTimeZoneResult.timeSlotStart;
      newSlotEnd = mapTimeZoneResult.timeSlotEnd;
    }

    return {
      timeSlotStart: newSlotStart,
      timeSlotEnd: newSlotEnd,
      dataTime: mapDateTimeToUtc(dataTime),
    };
  }

  onBtnUpdateClick = async (values) => {
    const errors = await this.validateFormData(values);
    if (Object.keys(errors).length) {
      const arrayErrors = Object.keys(errors);
      const input = document.querySelector(`#${arrayErrors[0]}`);

      if (input) {
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start',
        });
        throw new SubmissionError(errors);
      }
    }

    if (!this.state.languages.length) {
      this.languagesRef?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start',
      });
      return false;
    }

    if (!this.timeSlotsValid) {
      this.timeSlotsRef?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start',
      });
      return false;
    }

    let formData = new FormData();    //formdata object
    const inputCheck = this.getInputFields();
    [...INPUT_EN_FIELDS, ...INPUT_VN_FIELDS].forEach((key) => {
      if (values[key] && inputCheck.includes(key)) {
        formData.append(key, values[key]);   //append the values with key, value pair
      } else {
        formData.append(key, '');
      }
    });

    SELECT_FIELDS.forEach((key) => {
      if (values[key]) {
        formData.append(key, values[key].value);   //append the values with key, value pair
      }
    });

    const {isConfigOneSlot} = this.state;
    if (isConfigOneSlot) {
      this.setState({timeSlotTypeChoose: 'limit'});
      formData.append('isConfigOneSlot', isConfigOneSlot);
    }
    const dateTimeMapTimeZone = this.calculateDataTimes();
    formData.append('image', this.state.file);
    const { timeSlotStart, timeSlotEnd } = dateTimeMapTimeZone;
    if (this.state.timeSlotTypeChoose === 'limit') {
      formData.append('timeSlotStart', timeSlotStart);
      formData.append('timeSlotEnd', timeSlotEnd);
    }
    formData.append('timeSlotType', this.state.timeSlotTypeChoose);

    const dataTime = dateTimeMapTimeZone.dataTime;
    formData.append('dataTime', JSON.stringify(dataTime));
    this.state.languages.forEach((language, index) => {
      formData.append(`languages[${index}]`, language);
    })

    formData.append('roleBuddyInSession', String(this.state.roleBuddyInSession || 'volunteer'));
    // Ensure duration is converted to string for FormData (backend will convert back to number)
    formData.append('duration', String(this.state.duration || 20));

    let isDuplicate = 0;
    if (window.location.pathname.includes('duplicate-session')) {
      isDuplicate = 1;
    }
    formData.append('isDuplicate', isDuplicate);
    if (this.state.sessionId) {
      const { updateSession } = this.props;
      formData.append('id', this.state.sessionId);
      let dataCreate = await updateSession(formData);
      if (dataCreate && dataCreate.status === 'OK' && !isDuplicate) {
        toast.success(I18n.t('update_profile_info_success'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-success-container toast-success-container-after',
        });
        this.props.history.push('/session/' + this.state.sessionId);
      } else if (dataCreate && dataCreate.status === 'OK' && isDuplicate) {
        toast.success(I18n.t('create_topic_successful'), {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: 'colored',
          className: 'toast-success-container toast-success-container-after',
        });
        this.props.history.push('/session/' + dataCreate.data._id);
      } else {
        const message = dataCreate?.message || I18n.t('something_wrong');
        toast.error(message, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          className: 'toast-error-container toast-error-container-after',
          theme: 'colored',
        });
      }

      return;
    }
    const { createSession } = this.props;
    let dataCreate = await createSession(formData);
    if (dataCreate._id) {
      toast.success(I18n.t('create_topic_successful'), {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: 'colored',
        className: 'toast-success-container toast-success-container-after',
      });
      this.props.history.push('/session/' + dataCreate._id);
    } else {
      let message = I18n.t('something_wrong');
      toast.error(message, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        className: 'toast-error-container toast-error-container-after',
        theme: 'colored',
      });
    }
  };

  handleToggleLang = (lang) => {
    this.setState(prevState => {
      const { languages } = prevState;
      const itemIndex = languages.indexOf(lang);

      if (itemIndex !== -1 && languages.length > 1) {
        return {
          languages: languages.filter((_, index) => index !== itemIndex),
        };
      }
      else if (itemIndex === -1) {
        return {
          languages: [...languages, lang],
        };
      }
      // Nếu là phần tử cuối cùng => KHÔNG cho xóa
      else {
        return prevState;
      }
    });
  };

  checkCfl = (lang) => {
    return this.state.languages.includes(lang);
  }

  formatDay = (day) => {
    const getYear = day.getFullYear();
    const getMonth = String(day.getMonth() + 1).padStart(2, '0');
    const getDay = String(day.getDate()).padStart(2, '0');

    return `${getYear}-${getMonth}-${getDay}`;
  };

  handleShowNotVerifiedModal = (e) => {
    e && e.preventDefault();
    this.setState({ showNotVerifiedModal: true });
  };

  handleCloseNotVerifiedModal = () => {
    this.setState({ showNotVerifiedModal: false });
  };

  render() {
    const { header, footer, handleSubmit, listLanguage, user } = this.props;
    let {
      categories,
      existTime,
      timeSlotTypeChoose,
      isCreate,
      buddyRoles,
      roleBuddyInSession,
      duration,
      timeSlotConfig,
      timeSlotConfigOne,
      activeDateCalendar,
      oneSessionMessages,
      oneSessionOverlapWiths,
      oneSessionTime,
      timeSlotEnd,
      timeSlotStart,
      dataTime,
      oldDataTime,
      sessionId,
      durationTimes
    } = this.state;
    const timeSlotInfo = this.timeSlotInfo();
    const isNotVerified = user && user.statusVerify !== 'verified';
    return (
      <div id="site_wrapper">
        {header}
        <main className="main create-session">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-12">
                <div className="d-flex flex-column">
                  <img
                    className="cursor-pointer title-back"
                    src={arrowBackIcon}
                    alt="Arrow Back"
                    onClick={() => this.props.history.goBack()}
                  />
                  {
                    isCreate ? (<h3 className="title">{I18n.t('create_topic')}</h3>) :
                      (<h3 className="title">{I18n.t('edit_topic')}</h3>)
                  }
                </div>
                <div className="d-flex flex-column cfl" ref={(ref) => this.languagesRef = ref}>
                  <h5 className="title">{I18n.t('session_language')} <small className="error">*</small> ({I18n.t('multiple')})</h5>
                  <div className="d-flex">
                    {listLanguage.map((item, index ) => (
                      <div key={index} className="cfl-item" onClick={() => this.handleToggleLang(item.value)}>
                        {this.checkCfl(item.value) ? (
                            <FontAwesomeIcon
                              className="cursor-pointer"
                              icon={faCheckCircle} style={{ fontSize: '24px', color: '#61E6BD' }} />
                          )
                          :
                          (<div className="circle"></div>)
                        }
                        <span>{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <form className="col-12 px-0 form-create"
                      onSubmit={isNotVerified ? this.handleShowNotVerifiedModal : handleSubmit(this.onBtnUpdateClick)}
                >
                  <div className="general">
                    <h5>{I18n.t('overview')}</h5>
                    {this.checkCfl('vi') ? (
                        <div className="row">
                          <Field
                            label={`${I18n.t('session_title_label_required')} (${I18n.t('vietnamese')})`}
                            name="title"
                            type="text"
                            placeholder={I18n.t('session_title_hint')}
                            component={this.renderInput}
                            col={12}
                          />
                        </div>
                      )
                      :
                      null
                    }
                    {this.checkCfl('en') ? (
                        <div className="row">
                          <Field
                            label={`${I18n.t('session_title_label_required')} (${I18n.t('english')})`}
                            name="titleEn"
                            type="text"
                            placeholder={I18n.t('session_title_hint')}
                            component={this.renderInput}
                            col={12}
                          />
                        </div>
                      )
                      :
                      null
                    }
                    <div className="row">
                      <Field
                        label={I18n.t('dashboard_filter_category')}
                        name="categoryId"
                        component={this.renderCategorySelect}
                        options={categories}
                        col={12}
                      />
                    </div>
                    {existTime && (
                      <div className="row">
                        <div
                          className={`form-item col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12`}
                        >
                          <div className="existTime"
                               dangerouslySetInnerHTML={{ __html: existTime }}></div>
                        </div>
                      </div>
                    )}

                    <div className="row">
                      <Field
                        label={I18n.t('session_image_label_required')}
                        name="image"
                        previewLink={this.state.previewLink}
                        component={this.renderImage}
                        col={12}
                      />
                      <p style={{ marginTop: '8px', paddingLeft: '12px', fontSize: '14px', color: '#9CA3AF' }}>
                        {I18n.t('session_img_size')}
                      </p>
                    </div>

                    <div className="row">
                      <div className="form-item col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <span className="label d-block mt-3 mb-2">
                          {I18n.t('duration_of_each_session')}<small className="error">*</small>
                        </span>

                        {durationTimes.map((option) => (
                          <div key={option.value} onClick={() => this.durationSelect(option.value)}
                               className="d-flex align-items-center cursor-pointer mb-2">
                            <label className="radio-custom">
                              <input type="checkbox" checked={duration === option.value} onChange={() => this.durationSelect(option.value)} />
                              <div className="outer-circle">
                                <div className="inner-circle"></div>
                              </div>
                            </label>
                            <span
                              className="label">{option.value} {I18n.t('minutes')}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 form-item d-flex flex-column">
                        <span className="label d-flex align-content-center mt-3 mb-2">
                          {I18n.t('config_session')} <span className="error ml-1 mr-2">*</span>
                          <Tooltip title={I18n.t('session_tooltip_time_slot')} placement="top">
                            <img src={question} alt="tooltip" />
                          </Tooltip>
                        </span>
                        <ul>
                          {timeSlotInfo?.map((message, index) => (
                            <li key={index}>{message}</li>
                          ))}
                        </ul>
                        <div className="d-flex align-items-center" ref={(ref) => this.timeSlotsRef = ref}>
                          <button onClick={() => this.toggleConfigTimeSlot()} type="button"
                                  className="btn-time-slot cursor-pointer">
                            {I18n.t('config_session')}
                          </button>
                          <span className="ml-2 mr-2">{I18n.t('or')}</span>
                          <button onClick={() => this.toggleConfigOneSlot()} type="button"
                                  className="btn-time-slot cursor-pointer">
                            {I18n.t('config_one_session')}
                          </button>
                        </div>
                        {!this.timeSlotsValid && (
                          <span className="error-message mt-1 ml-2">
                          <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                            {I18n.t('text_field_required_error')}
                        </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-item col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <span className="label d-block mt-3 mb-2">
                                          {I18n.t('dashboard_filter_provider')}<small className="error">*</small>
                                        </span>
                        {buddyRoles.map((option) => (
                          <div key={option.value} onClick={() => this.buddyRoleSelect(option.value)}
                               className="d-flex align-items-center cursor-pointer mb-2">
                            <label className="radio-custom">
                              <input type="checkbox" checked={roleBuddyInSession === option.value} onChange={() => this.buddyRoleSelect(option.value)} />
                              <div className="outer-circle">
                                <div className="inner-circle"></div>
                              </div>
                            </label>
                            <span
                              className="label">{option.label}{option.description ? ` - ${option.description}` : ''}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="detail">
                    <h5 className="mb-0">{I18n.t('session_detail_information')}</h5>
                    {this.checkCfl('vi') ? (
                        <div className="row">
                          <Field
                            label={`${I18n.t('session_buddy_hint')} (${I18n.t('vietnamese')})`}
                            name="personalDescription"
                            placeholder={I18n.t('session_buddy_hint')}
                            component={this.renderTextarea}
                            col={12}
                          />
                        </div>
                      )
                      :
                      null
                    }
                    {this.checkCfl('en') ? (
                        <div className="row">
                          <Field
                            label={`${I18n.t('session_buddy_hint')} (${I18n.t('english')})`}
                            name="personalDescriptionEn"
                            placeholder={I18n.t('session_buddy_hint')}
                            component={this.renderTextarea}
                            col={12}
                          />
                        </div>
                      )
                      :
                      null
                    }
                    {this.checkCfl('vi') ? (
                        <div className="row">
                          <Field
                            label={`${I18n.t('session_description_hint')} (${I18n.t('vietnamese')})`}
                            name="description"
                            placeholder={I18n.t('session_description_hint')}
                            component={this.renderTextarea}
                            col={12}
                          />
                        </div>
                      )
                      :
                      null
                    }
                    {this.checkCfl('en') ? (
                        <div className="row">
                          <Field
                            label={`${I18n.t('session_description_hint')} (${I18n.t('english')})`}
                            name="descriptionEn"
                            placeholder={I18n.t('session_description_hint')}
                            component={this.renderTextarea}
                            col={12}
                          />
                        </div>
                      )
                      :
                      null
                    }
                  </div>

                  <button type="submit" className={`btn-create-session${isNotVerified ? ' btn-disabled' : ''}`}
                          onClick={isNotVerified ? this.handleShowNotVerifiedModal : undefined}
                  >
                    {
                      isCreate ? (I18n.t('create_topic')) : (I18n.t('edit_topic'))
                    }
                  </button>
                </form>
                {timeSlotConfig && (
                  <ConfigTimeSlots
                    sessionDuration={Number(this.state.duration) || 45}
                    topicId={sessionId}
                    dataTime={dataTime}
                    oldDataTime={oldDataTime}
                    timeSlotStart={timeSlotStart}
                    timeSlotEnd={timeSlotEnd}
                    timeSlotConfig={timeSlotConfig}
                    timeSlotTypeChoose={timeSlotTypeChoose}
                    buddyTimeslotTypeSelect={this.buddyTimeslotTypeSelect}
                    toggleConfigTimeSlot={this.toggleConfigTimeSlot}
                    prepareTimeSlotConfig={this.prepareTimeSlotConfig}
                    timeSlotTypeDateChange={this.timeSlotTypeDateChange}
                  />
                )}
              </div>
            </div>
          </div>
        </main>
        {footer}
        <NotVerifiedModal
          visibleModal={this.state.showNotVerifiedModal}
          closeModal={this.handleCloseNotVerifiedModal}
        />
        <Modal
          id="modal-config-one-slot"
          size="lg"
          visible={timeSlotConfigOne}
          dialogClassName="modal-dialog-centered">
          <div className="modal-body">
            <div className="d-flex align-items-center">
              <img
                className="cursor-pointer mr-3"
                src={arrowBackIcon}
                alt="Arrow Back"
                onClick={() => this.toggleConfigOneSlot()}
              />
              <span className="modal-title">{I18n.t('config_one_session')}</span>
            </div>
            <div className="section"></div>
            <div className="d-flex justify-content-center flex-column">
              <span>{I18n.t('config_one_session_step_1')} <small style={{ color: 'red' }}>*</small></span>
              <div ref={this.calendarRef}>
                <Calendar
                  next2Label={null}
                  prev2Label={null}
                  locale={locale}
                  navigationLabel={({ date, label, locale, view }) => {
                    const month = date.toLocaleDateString(locale, { month: 'long' });
                    const year = date.getFullYear();
                    return `${month}, ${year}`;
                  }}
                  value={activeDateCalendar}
                  minDetail={'month'}
                  onClickDay={async (value) => {
                    const inputDate = moment(value).startOf('day');
                    const currentDate = moment().startOf('day');
                    if (inputDate.isBefore(currentDate)) {
                      return null
                    }
                    this.setActiveDateCalendar(value);
                  }}
                  tileClassName={({ activeStartDate, date, view }) => {
                    const inputDate = moment(date).startOf('day');
                    const currentDate = moment().startOf('day');
                    if (inputDate.isBefore(currentDate)) {
                      return 'can-not-register';
                    }
                    return 'can-register';
                  }}
                />
                <div className="cld-footer"></div>
              </div>
            </div>
            {activeDateCalendar ?
              (
                <>
                  <div className="section"></div>
                  <span>{I18n.t('config_one_session_step_2', {date: moment(activeDateCalendar).format('DD/MM/YYYY')})} <small style={{ color: 'red' }}>*</small></span>
                  <div className="d-flex align-items-center mt-4" style={{ gap: '12px' }}>
                    <TimePicker
                      placeholder={null}
                      className="tlsi-picker"
                      suffixIcon={null}
                      allowClear={false}
                      onChange={(time) => this.handleChangeTime(time)}
                      value={moment(oneSessionTime.start, 'HH:mm')} format={'HH:mm'}
                    />
                    <span style={{ fontSize: '16px' }}>{I18n.t('to')}</span>
                    <Tooltip title={I18n.t('config_session_tooltip_time')} placement="top">
                      <TimePicker
                        className="tlsi-picker"
                        placeholder={null}
                        disabled={true}
                        suffixIcon={null}
                        allowClear={false}
                        value={moment(oneSessionTime.end, 'HH:mm')} format={'HH:mm'}
                      />
                    </Tooltip>
                  </div>
                  {oneSessionMessages && (
                    <span className="error-message mt-1">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                      {oneSessionMessages}
                    </span>
                  )}
                  {oneSessionOverlapWiths?.length ? (
                    <div className="d-flex justify-content-center flex-column">
                    <span className="error-message mt-1">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                      {I18n.t('session_date_time_error')}. {I18n.t('details')}
                    </span>
                      <div className="error-overlap mt-1">
                        {I18n.t('config_session_time_multi_hint')}
                        <ul className="mb-0 pl-3">
                          {oneSessionOverlapWiths?.map(over => (
                            <li>{I18n.t('config_session_overlap_hint', {
                              x: over.timeSlot,
                              y: over.session
                            })}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ) : ''}
                </>)
              : null}
            <div className="section"></div>
            <div className="d-flex align-items-center justify-content-end">
              <button
                onClick={() => this.cancelConfig()}
                type="button"
                className="btn-time-slot cursor-pointer">
                {I18n.t('cancel')}
              </button>
              <button
                onClick={() => this.saveConfig()}
                type="button"
                style={{ color: '#000000', background: '#61E6BD' }}
                className="btn-time-slot ml-4 cursor-pointer">
                {I18n.t('save')}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    submitErrors: getFormSubmitErrors(FORM_NAME)(state),
    listLanguage: state.mvp.listLanguage,
    user: state.user,
  };
};

const mapDispatchToProps = {
  getCategorySessions,
  createSession,
  getDetailSession,
  getDetailTopic,
  updateSession,
  uploadFile,
  getListBuddyRole,
  verifySlotSession,
  getListDurationByLevel
};
export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: false,
  })(CreateSession),
);
